import transactions from '../response/transactions/transactions.json';
import transactionDetail from '../response/transactions/transaction-detail.json';
import acquiringContractAddress from '../response/transactions/account-acquiring-contract-address.json';

export default function TransactionRoutes () {
  this.get('/transactions-api/v1/fleet/transactions', () => transactions);
  this.get('/transactions-api/v1/fleet/transactions/:accountId;:transactionId', () => transactionDetail);

  // Get acquiring contract address
  this.get('accounts-api/v1/accounts/contract/acquire/address/:contractIdentifier', () => acquiringContractAddress);
}
